import { useEffect, useState } from "react";
import { fetchImageData, upsertLabel } from "./ApiRequests";
import {
  Box,
  Button,
  Typography,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
 } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";

export default function ImageView({ authToken }) {
  const [data, setData] = useState(null);
  const [label, setLabel] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const s3_path = params.get("s3_path");

  useEffect(() => {
    if (!authToken || !s3_path) return;
    fetchImageData(s3_path, authToken)
      .then(d => {
        setData(d);
      })
      .catch(e => console.error(e));
  }, [s3_path, authToken]);

  async function save() {
    try {
      await upsertLabel(s3_path, label, authToken);
      const d = await fetchImageData(s3_path, authToken);
      setData(d);
      setLabel("");
      alert("Saved");
    } catch (err) {
      console.error(err);
      alert("Failed to save");
    }
  }

  if (!s3_path) return <Typography>No image selected</Typography>;
  if (!data)
    return (
      <Box display="flex" justifyContent="center" mt={4}>
        <CircularProgress />
      </Box>
    );

  return (
    <Box p={2}>
      <Button variant="contained" onClick={() => navigate(-1)} sx={{ mb: 2 }}>
        Back
      </Button>

      <Paper sx={{ p: 2, mb: 2 }}>
        <Typography variant="h6" gutterBottom>
          {data.s3_path}
        </Typography>
        <Box
          component="img"
          src={`/v1/image?s3_path=${encodeURIComponent(data.s3_path)}`}
          alt="Selected"
          sx={{ maxWidth: "100%", height: "auto", borderRadius: 1 }}
        />
      </Paper>
      <Paper sx={{ p: 2, mb: 2 }}>
        <Typography variant="subtitle1" gutterBottom>
          Existing Labels
        </Typography>

        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>User</TableCell>
                <TableCell align="right">Label</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.label_data.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>{row.user}</TableCell>
                  <TableCell align="right">{row.label}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      <Paper sx={{ p: 2 }}>
        <Typography variant="subtitle1" gutterBottom>
          Label ({process.env.REACT_APP_LABEL_NAME})
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
          value={label}
          onChange={e => setLabel(e.target.value)}
          sx={{ mb: 2 }}
        />
        <Button variant="contained" color="primary" onClick={save}>
          Save
        </Button>
      </Paper>
    </Box>
  );
}
